import { board } from "./game/gameBoard_v2.js";
import { COLOR_SCHEMES } from "./constants_v2.js";
import { profile } from "./profile/profile_v2.js";
import { newMatch } from "./matches/newMatch_v2.js";
import { currentMatch } from "./matches/currentMatch_v2.js";
import { scoreBoard } from "./scoreBoard/scoreBoard_v2.js";
import { join } from "./matches/join_v2.js";
import { matchService } from "./matches/matchService_v2.js";
import { help } from "./help_v2.js";
import { zoom } from "./zoom_v2.js";
import { recentMatches } from "./matches/recentMatches_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { leaderboard } from "./leaderboard_v2.js";

var colorState = {
  scheme: "muted",
  player: {
    playerOne: {
      piece: "#ebe6da",
      pieceGray: "#e6e6df",
      direction: "#f5fbfc",
      directionGray: "#d9d9d4",
      hover: "white",
    },
    playerTwo: {
      piece: "#A59D84",
      pieceGray: "#bfbeba",
      direction: "#363534",
      directionGray: "#a6a5a2",
      hover: "black",
    },
  },
  game: {
    hexGrid: "#d1d0cb",
    background: "#d4d3cd",
    darkAccent: "#9e9079ff",
    accent: "#dbcea7",
    lightAccent: "#cfc8b4",
    lighterAccent: "#ede8d8",
    messageBackground: "#ebeae4",
    hex_available: "#93e01f",
  },
};

const isSchemeValid = (scheme) => {
  if (COLOR_SCHEMES.includes(scheme)) {
    return true;
  } else {
    return false;
  }
};

const setScheme = (scheme) => {
  if (!isSchemeValid(scheme)) {
    console.log(
      "Error: Attempt to set color scheme to this invalid value: " + scheme,
    );
    return;
  }
  switch (scheme) {
    case "muted":
      colorState = JSON.parse(JSON.stringify(mutedColors)); //clone
      break;
    case "desert":
      colorState = JSON.parse(JSON.stringify(desertColors)); //clone
      break;
    case "dark":
      colorState = JSON.parse(JSON.stringify(darkColors)); //clone
      break;
    case "jenn":
      colorState = JSON.parse(JSON.stringify(jennColors)); //clone
      break;
  }
  setBackgroundColors();
  setButtonColors();
  setNavColors();
  zoom.render();

  board.render(); //update to all the new colors
  scoreBoard.render();
  
  // Update chat colors if available (avoid circular import)
  if (window.chat && typeof window.chat.updateColors === 'function') {
    window.chat.updateColors();
  }
};

const handlePointerOverButton = (event, element) => {
  element.style.backgroundColor = getGameColor("iPop");
};
const handlePointerOutButton = (event, element) => {
  element.style.backgroundColor = getGameColor("accent");
};

const setBackgroundColors = () => {
  document.getElementById("app").style.backgroundColor =
    colors.getGameColor("background");
  document.getElementById("canvas").style.borderColor =
    colors.getGameColor("messageBackground");
  document.body.style.backgroundColor =
    colors.getGameColor("messageBackground");
  document.getElementById("canvas").style.backgroundColor =
    colors.getGameColor("background");
};

const setButtonColors = () => {
  const buttons = document.querySelectorAll("button");
  for (const button of buttons) {
    // not all buttons are available at all times, so...
    if (button) {
      let color = getGameColor("accent");
      button.classList.remove("boxshadow");

      button.style.backgroundColor = color;
      eventHub.registerEvent("pointerover", button.id, handlePointerOverButton);
      eventHub.registerEvent("pointerout", button.id, handlePointerOutButton);
    }
  }

  // and list controls

  const invitationsList = document.getElementById("invitationsList");
  if (invitationsList) {
    invitationsList.style.backgroundColor = getGameColor("messageBackground");
  }
  const gamesActiveList = document.getElementById("gamesActiveList");
  if (gamesActiveList) {
    gamesActiveList.style.backgroundColor = getGameColor("messageBackground");
  }
};

const setNavColors = () => {
  configureNavColors({
    element: document.getElementById("newSection"),
    size: newMatch.getSize(),
  });
  configureNavColors({
    element: document.getElementById("newNav"),
    size: newMatch.getSize(),
  });
  addHover(document.getElementById("newNav"));
  configureNavColors({
    element: document.getElementById("currentMatchSection"),
    size: currentMatch.getSize(),
  });
  configureNavColors({
    element: document.getElementById("currentMatchNav"),
    size: currentMatch.getSize(),
  });
  addHover(document.getElementById("currentMatchNav"));
  configureNavColors({
    element: document.getElementById("profileSection"),
    size: profile.size(),
  });
  configureNavColors({
    element: document.getElementById("profileNav"),
    size: profile.size(),
  });
  addHover(document.getElementById("profileNav"));
  configureNavColors({
    element: document.getElementById("joinSection"),
    size: join.getSize(),
  });
  configureNavColors({
    element: document.getElementById("joinNav"),
    size: join.getSize(),
  });
  addHover(document.getElementById("joinNav"));
  configureNavColors({
    element: document.getElementById("leaderboardSection"),
    size: leaderboard.getSize(),
  });
  configureNavColors({
    element: document.getElementById("leaderboardNav"),
    size: leaderboard.getSize(),
  });
  addHover(document.getElementById("leaderboardNav"));
  configureNavColors({
    element: document.getElementById("helpNav"),
    size: help.getSize(),
  });
  addHover(document.getElementById("helpNav"));
  configureNavColors({
    element: document.getElementById("helpSection"),
    size: help.getSize(),
  });
  configureNavColors({
    element: document.getElementById("recentMatchesNav"),
    size: recentMatches.getSize(),
  });
  addHover(document.getElementById("recentMatchesNav"));
  configureNavColors({
    element: document.getElementById("recentMatchesSection"),
    size: recentMatches.getSize(),
  });
};

const configureNavColors = ({ element, size }) => {
  switch (size) {
    case "small":
      element.style.backgroundColor = getGameColor("accent");
      //addHover(element); // when small, helps you realize it's clickable
      break;
    case "normal":
      element.style.backgroundColor = getGameColor("lighterAccent");
      //removeHover(element); // but that's annoying when it's large
      break;
    default:
      navBack = getGameColor("accent");
      break;
  }
  element.style.borderColor = getGameColor("hexGrid");
};

const handleMouseEnter = (event) => {
  const gotEntered = event.target;
  gotEntered.style.backgroundColor = getGameColor("iPop");
};

const handleMouseLeave = (event) => {
  const gotEntered = event.target;
  gotEntered.style.backgroundColor = getGameColor("accent");
};

const addHover = (element) => {
  eventHub.registerEvent("pointerover", element.id, handleMouseEnter);
  eventHub.registerEvent("pointerout", element.id, handleMouseLeave);
};

const getPlayerColor = ({ player, property }) => {
  if (!matchService.isPlayerValid(player)) {
    console.log(
      "Error: attempted to get the colors of an invalid player: " + player,
    );
    return;
  }
  if (
    !["piece", "pieceGray", "direction", "directionGray", "hover"].includes(
      property,
    )
  ) {
    console.log(
      "Error: attempted to get the colors of an invalid player property: " +
        property,
    );
    return;
  }
  return colorState.player[player][property];
};

const getGameColor = (property) => {
  if (
    ![
      "hexGrid",
      "background",
      "double",
      "accent",
      "darkAccent",
      "lightAccent",
      "lighterAccent",
      "messageBackground",
      "hex_available",
      "tip",
      "iPop",
    ].includes(property)
  ) {
    console.log(
      "Error: attempted to get the colors of an invalid game property: " +
        property,
    );
    return;
  }
  return colorState.game[property];
};

const getScheme = () => {
  return colorState.scheme;
};

const mutedColors = {
  scheme: "muted",
  player: {
    playerOne: {
      piece: "#ebe6da",
      pieceGray: "#e6e6df",
      direction: "#f5fbfc",
      directionGray: "#d9d9d4",
      hover: "white",
    },
    playerTwo: {
      piece: "#A59D84",
      pieceGray: "#bfbeba",
      direction: "#363534",
      directionGray: "#a6a5a2",
      hover: "black",
    },
  },
  game: {
    hexGrid: "#d1d0cb",
    background: "#d4d3cd",
    double: "#b5cab6ff",
    darkAccent: "#afa89cff",
    accent: "#d1bf9fff",
    lightAccent: "#cfc8b4",
    lighterAccent: "#ede8d8",
    messageBackground: "#f8f8f8ff",
    hex_available: "#8ae403ff",
    tip: "#e8dcc4",
    iPop: "#fbe9c9ff",
  },
};

const desertColors = {
  scheme: "desert",
  player: {
    playerOne: {
      piece: "#FFCDB2",
      pieceGray: "#edcebdff",
      direction: "#2f2b35ff",
      directionGray: "#47454bff",
      hover: "#ffffffff",
    },
    playerTwo: {
      piece: "#B5838D",
      pieceGray: "#a99095ff",
      direction: "#ffffffff",
      directionGray: "#d8d5d5ff",
      hover: "#c46477ff",
    },
  },
  game: {
    hexGrid: "#dbd1ccff",
    background: "#e2d3cbff",
    double: "#d5e8caff",
    accent: "#e8b5a4ff",
    darkAccent: "#ae897dff",
    lightAccent: "#ffe2cdff",
    lighterAccent: "#fbe9ddff",
    messageBackground: "#faf2edff",
    hex_available: "#82ed10ff",
    tip: "#f7d4bbff",
    iPop: "#ffead2",
  },
};

const darkColors = {
  scheme: "dark",
  player: {
    playerOne: {
      piece: "#7a7a8cff",
      pieceGray: "#93939cff",
      direction: "#ada8a8ff",
      directionGray: "#9f9c9cff",
      hover: "rgb(162, 158, 158)",
    },
    playerTwo: {
      piece: "rgb(74, 72, 72)",
      pieceGray: "rgb(120, 120, 120)",
      direction: "#181818",
      directionGray: "#12100fff",
      hover: "#706e6e",
    },
  },
  game: {
    hexGrid: "#565555ff",
    background: "#5a5a5aff",
    double: "#729e74ff",
    darkAccent: "#575757ff",
    accent: "#8c8c91ff",
    lightAccent: "#717171ff",
    lighterAccent: "#b1b3bb",
    messageBackground: "#3e3d3dff",
    hex_available: "#77b437ff",
    tip: "#a8a9af",
    iPop: "rgb(170, 170, 170)",
  },
};

// let's try something like this:
// https://coolors.co/palette/03045e-0077b6-00b4d8-90e0ef-caf0f8
const jennColors = {
  scheme: "jenn",
  player: {
    playerOne: {
      piece: "#90E0EF",
      pieceGray: "#90d5e1ff",
      direction: "#ffffffff",
      directionGray: "#d4ededff",
      hover: "#ecfcffff",
    },
    playerTwo: {
      piece: "#27afcaff",
      pieceGray: "#51bdd3ff",
      direction: "#021227ff",
      directionGray: "#475568ff",
      hover: "#006ba1ff",
    },
  },
  game: {
    hexGrid: "#b3d4e5ff",
    background: "#b3d9ecff",
    double: "#a6d6a8ff",
    darkAccent: "#597c8fff",
    accent: "#9cd6d7ff",
    lightAccent: "#d3e8f2ff",
    lighterAccent: "#d2e8f4ff",
    messageBackground: "#edf6fdff",
    hex_available: "#86ff05ff",
    tip: "#c4deeeff",
    iPop: "#e6eef5",
  },
};

const easterColors = {
  scheme: "easter",
  player: {
    playerOne: {
      piece: "#dbc2ffff",
      pieceGray: "#cebee4ff",
      direction: "#ffffffff",
      directionGray: "#d7dae2ff",
      hover: "#ffffffff",
    },
    playerTwo: {
      piece: "#83b7fcff",
      pieceGray: "#7da4d7ff",
      direction: "#2380faff",
      directionGray: "#6784abff",
      hover: "#0058ccff",
    },
  },
  game: {
    hexGrid: "#cdecfef2",
    background: "#d5edfcf2",
    double: "#b5cab6ff",
    accent: "#c1fbd5ff",
    lightAccent: "#dbf9ecff",
    lighterAccent: "#f5fffbff",
    messageBackground: "#f1f5f8ff",
    hex_available: "#86ff05ff",
    tip: "#c5f6e2ff",
    iPop: "#fff2afff",
  },
};

export const colors = {
  isSchemeValid,
  setScheme,
  setButtonColors,
  setNavColors,
  getPlayerColor,
  getGameColor,
  getScheme,
  mutedColors,
  desertColors,
  darkColors,
  jennColors,
};

// Make colors available globally for other modules
if (typeof window !== 'undefined') {
  window.colors = colors;
}
